const Card = ({ title, description, name, city, backgroundColor }) => {
  return (
    <div
      className="w-[311px] h-full md:w-[280px] md:h-[400px] max-w-full flex-shrink-0 rounded-2xl p-6 flex flex-col justify-start transition-all duration-300 ease-in-out hover:-translate-y-1 shadow-sm"
      style={{ backgroundColor: backgroundColor || "#F5F7FA" }}
    >
      <div className="flex flex-col h-full justify-between">
        <div className="flex-grow">
          <h2 className="font-helvetica font-semibold text-base mb-4 text-gray-700">
            {title}
          </h2>
          <p
            style={{ fontFamily: "Georgia, serif" }}
            className="font-serif text-base leading-relaxed text-gray-600"
          >
            {description}
          </p>
        </div>
        <div className="mt-6">
          <h2 className="font-helvetica font-semibold text-base text-gray-800">
            {name}
          </h2>
          <p className="font-helvetica text-sm text-gray-600">{city}</p>
        </div>
      </div>
    </div>
  );
};

export default Card;
